/**
 * Checks if the given value is an empty object.
 *
 * @param {any} value - The value to check.
 * @return {boolean} - True if the value is an empty object, false otherwise.
 */
export function isEmptyObject(value: any): boolean {
    return Object.prototype.toString.call(value) === '[object Object]' && Object.keys(value).length === 0;
}
